import React, { useEffect, useState } from 'react';
import { withStyles } from '@material-ui/core';
import Navbar from './Navbar';
import Sidebar from './Sidebar';
import Span from '@material-ui/core/Box';
import Snackbar from '../../components/Snackbar/Snackbar';
import { getSessionToken } from "../../utils/authentication/jwtUtils.js";
import { ValidateSessionTokenAPI } from '../../helper/services/API/Users';
//import Footer from '../../components/Footer/Footer';
import { UserAccountContext } from '../../contextHooks';
import Loader from '../../helper/loaders/ComponentLoader';
import { setCookieStorage } from "../../utils/CookieLocalStorage";

const styles = (theme) => ({
    BannerContainer: { background: '#333', padding: '6px 10px', borderLeft: '4px solid #ffa500', borderRadius: 4, marginLeft: 29, marginRight: 29, marginBottom: 12 },
    BannerText: { color: '#fff', fontSize: 13, fontWeight: 500 },
    mainContent: {
        marginRight: 32,
        marginLeft: 100,
        marginTop: 80
    },
    [theme.breakpoints.only('xs')]: {
        mainContent: {
            marginRight: 12,
            marginLeft: 12,
            marginTop: 80
        }
    },
});

const DashboardLayout = (Props) => {
    const { classes, children } = Props;
    const childrenProps = children.props;
    const [userAccount, setUserAccount] = useState({});
    const [snackbarState, setSnackbarState] = useState({
        messageInfo: {
            open: false,
            message: null,
            variant: 'success'
        }
    });
    
    const setUserDataContext = (res) =>{
        if(res.success && res.data){
            setUserAccount(res.data);
        }
        else if (res.message_code === 30001) {
            setSnackbarState({
                messageInfo: {
                    open: true,
                    message: res.message,
                    variant: 'error'
                }
            });
            setCookieStorage('session_token', null, { path: '/', sameSite: true });
            childrenProps.history.push('/auth/login');
        }
        else {
            setSnackbarState({
                messageInfo: {
                    open: true,
                    message: 'Something went wrong!',
                    variant: 'error'
                }
            });
        }
    }

    useEffect(() => {
        (async () => {
            let tokenInfo = await validateToken();
            setUserDataContext(tokenInfo);
            if (!getSessionToken()) {
                childrenProps.history.push('/auth/login');
            }
        })().catch(err => {
            console.error('Caught error :', err);
            setSnackbarState({
                messageInfo: {
                    open: true,
                    message: 'Something went wrong!',
                    variant: 'error'
                }
            });
        });

        //The "react-hooks/exhaustive-deps" rule warns us when we have a missing dependency in an effect hook. To get rid of the warning, move the function or variable declaration inside of the useEffect hook, memoize arrays and objects that change on every render or disable the rule.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [childrenProps]);

    const validateToken = async () => {
        try {
            let tokenState = await ValidateSessionTokenAPI();
            return tokenState;
        } catch (error) {
            throw error;
        };
    };

    return (
        <React.Fragment>
            {snackbarState.messageInfo.open && 
                <Snackbar
                    message={snackbarState.messageInfo.message}
                    open={snackbarState.messageInfo.open}
                    closeSnackBar={() => {
                        setSnackbarState({ messageInfo: { open: false, message: null, variant: 'success' } });
                    }}
                    variant={snackbarState.messageInfo.variant}
                    autoHideDuration={5000}
                />
            }
            {
                Object.keys(userAccount).length > 0 ?
                    <React.Fragment>
                        <UserAccountContext.Provider value={userAccount}>
                            <Navbar />
                            <Sidebar />
                            <Span className={classes.mainContent}>
                                {children}
                                {/* <Footer /> */}
                            </Span>
                        </UserAccountContext.Provider>
                    </React.Fragment>
                    : <Loader />
            }
        </React.Fragment>
    );
}
export default withStyles(styles)(DashboardLayout);
